import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LandingNav from "./LandingNav";
import api from "../lib/api";

export default function LandingShell({ title, subtitle, icon: Icon, children, wide = false }) {
  const [contact, setContact] = useState(null);
  useEffect(() => {
    api.get("/site-settings").then(({ data }) => setContact(data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-su-bg text-su-text overflow-x-hidden flex flex-col">
      <LandingNav />
      <main className={`flex-1 w-full mx-auto px-4 py-10 sm:py-14 ${wide ? "max-w-7xl" : "max-w-5xl"}`}>
        {title && (
          <div className="mb-8">
            {Icon && (
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-su-primary/15 mb-4">
                <Icon className="w-6 h-6 text-su-primary" />
              </div>
            )}
            <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">{title}</h1>
            {subtitle && <p className="text-su-muted font-medium text-base lg:text-lg mt-3 max-w-2xl">{subtitle}</p>}
          </div>
        )}
        {children}
      </main>

      <footer className="border-t-2 border-su-border py-8 text-center">
        <p className="font-heading font-extrabold text-su-muted">SkorUp<span className="text-su-primary">.io</span> © 2026 · Level up your score.</p>
        <div className="flex items-center justify-center gap-3 mt-3 flex-wrap text-sm font-heading font-bold text-su-muted">
          <Link to="/faq" className="hover:text-su-primary">FAQ</Link><span className="text-su-border">·</span>
          <Link to="/terms" className="hover:text-su-primary">Syarat & Ketentuan</Link><span className="text-su-border">·</span>
          <Link to="/refund" className="hover:text-su-primary">Kebijakan Refund</Link><span className="text-su-border">·</span>
          <Link to="/contact" className="hover:text-su-primary">Kontak</Link>
        </div>
        {contact?.email && <p className="text-sm text-su-muted font-medium mt-3">{contact.email}{contact?.whatsapp ? ` · ${contact.whatsapp}` : ""}</p>}
        <p className="text-xs text-su-muted font-medium mt-3">© 2026 PT. Ruang Karya Teknologi. All Rights Reserved.</p>
      </footer>
    </div>
  );
}
